import type { TFunction } from 'i18next';
import { secondaryBase } from '../../../../../styles/design-tokens';
import { Icon } from '../../../../../ui-library/icon/icon';
import type { ExtendedComboboxItem } from '../../../../../ui-library/select/select.type';
import { FocusMode } from '../../initiative-performance.type';

/**
 * Returns a list of options for the focus mode dropdown
 *
 * @param {TFunction} t - Translation function from `useTranslation()`
 * @returns {ExtendedComboboxItem[]} Array of options for the focus mode selection
 */
const getFocusModeOptions = (t: TFunction): ExtendedComboboxItem[] => {
  return [
    {
      label: t('strategy.initiative_performance.labels.contributing_teams'),
      value: FocusMode.ContributingTeams,
      leftSection: <Icon name="people_alt" size={20} color={secondaryBase} />,
    },
    {
      label: t('strategy.initiative_performance.labels.contributing_boards'),
      value: FocusMode.ContributingBoards,
      leftSection: <Icon name="view_kanban" size={20} color={secondaryBase} />,
    },
  ];
};

export { getFocusModeOptions };
